import React, { useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'
import { useIntl } from 'react-intl'
import imglogo from '../../../assets/img/logo_t4i.png'
import bgAuthenticate from '../../../assets/img/bg-authenticate.png'
import { useAuthentication } from '../../../customHooks/useAuthentication'
import { requestAndRegisterToken } from '../../../services/firebaseMessaging'
import paths from '../../../routes/paths'
import { LOGIN_LIFECYCLE_CODES } from '../../Account/lifecycle/lifecycle.constants'
import { SignupLifecycleNotice } from '../signup/components/SignupLifecycleNotice'
import {
  exchangeStaffGoogle,
  readStaffGoogleResume,
  staffGoogleMessage,
  stashStaffGoogleCompletion,
  stashStaffGoogleReauth,
} from '../../../services/staffGoogle'
import '../login.css'

function GoogleReturn() {
  const { formatMessage: trans } = useIntl()
  const history = useHistory()
  const { setCurrentToken, updateUserInfo } = useAuthentication()
  const [error, setError] = useState('')
  const [notice, setNotice] = useState(null)
  const started = React.useRef(false)

  useEffect(() => {
    if (started.current) return
    started.current = true
    const params = new URLSearchParams(window.location.search)
    const code = params.get('code') || ''
    const purpose = params.get('purpose') || 'login'
    const providerError = params.get('error') || ''
    window.history.replaceState({}, document.title, window.location.pathname)

    if (providerError) {
      setError(staffGoogleMessage(trans, { code: providerError }))
      return
    }
    if (!code) {
      setError(trans({ id: 'staff_google_code_expired', defaultMessage: 'This Google sign-in expired. Start again.' }))
      return
    }
    if (sessionStorage.getItem('staff_google_exchange_once') === code) return
    sessionStorage.setItem('staff_google_exchange_once', code)

    exchangeStaffGoogle(code, purpose).then((res) => {
      const data = res?.data || {}
      if (data.outcome === 'authenticated' && data.access_token) {
        localStorage.setItem('jwt_token', JSON.stringify(data.access_token))
        setCurrentToken(JSON.parse(localStorage.getItem('jwt_token')))
        updateUserInfo(data.user, { replace: true })
        requestAndRegisterToken()
        history.replace(paths.dashboard)
        return
      }
      if (data.outcome === 'complete_registration' && data.completion_code) {
        stashStaffGoogleCompletion({
          completion_code: data.completion_code,
          profile: data.profile || {},
          missing: data.missing || ['companyName'],
        })
        history.replace('/auth/google/finish')
        return
      }
      if (data.outcome === 'linked') {
        history.replace('/profile')
        return
      }
      if (data.outcome === 'reauthenticated' && data.reauth_code) {
        const resume = readStaffGoogleResume()
        stashStaffGoogleReauth(data.reauth_code, resume?.action || '')
        history.replace(resume?.path || '/profile')
        return
      }
      const codeName = data.code || data.error
      if (codeName && LOGIN_LIFECYCLE_CODES.has(codeName)) {
        setNotice({ code: codeName, message: data.message || '' })
        return
      }
      setError(staffGoogleMessage(trans, data))
    })
  }, [history, setCurrentToken, trans, updateUserInfo])

  return (
    <div className="login">
      <div className="hero-split">
        <img alt="" className="hero-image" src={bgAuthenticate} />
      </div>
      <div className="form-split">
        <div className="form-container">
          <div className="form-container_top">
            <img alt="Tech4Inventory" className="logo" src={imglogo} />
            <h1 className="title-app">Tech4Inventory</h1>
            <span className="subtitle-app">{trans({ id: 'staff_google_return_working', defaultMessage: 'Contacting Google…' })}</span>
          </div>
          {notice ? <SignupLifecycleNotice code={notice.code} apiMessage={notice.message} email="" /> : null}
          {error ? (
            <p className="message_error" role="alert">
              {error}
            </p>
          ) : null}
          {error || notice ? (
            <button type="button" className="secondary-button" onClick={() => history.push('/')}>
              {trans({ id: 'staff_google_back_to_login', defaultMessage: 'Back to sign in' })}
            </button>
          ) : null}
        </div>
      </div>
    </div>
  )
}

export default GoogleReturn
